/*!
 * 
 *        inpl.ads-sidebar - Delivery scrolling ads service
 *        Author: vladyslav.ovinnikov@firma.interia.pl
 *        Version: 2.0.22
 *        License(s): ISC
 *     
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("inpl.ads-sidebar", [], factory);
	else if(typeof exports === 'object')
		exports["inpl.ads-sidebar"] = factory();
	else
		root["inpl.ads-sidebar"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Copyright (c) 2017.  INTERIA.PL (www.interia.pl)
 **/
/**
 * @param {Element} el
 * @returns {number}
 */
var outerHeightWithMargin = function outerHeightWithMargin(el) {

    var height = el.offsetHeight;

    var style = getComputedStyle(el);

    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);

    return height;
};

/**
 * Created by vladyslav on 27.11.17.
 */
var windowLoaded = function windowLoaded() {
    return new Promise(function (resolve) {
        if (document.readyState === 'complete') {
            resolve();
        } else {
            document.addEventListener('readystatechange', function () {
                if (document.readyState === 'complete') {
                    resolve();
                }
            });
        }
    });
};

exports.windowLoaded = windowLoaded;
exports.outerHeightWithMargin = outerHeightWithMargin;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) 2017.  INTERIA.PL (www.interia.pl)
 **/

/**
 * Created by vladyslav on 27.11.17.
 */
var OFFSET_TOP = exports.OFFSET_TOP = 40;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright (c) 2017.  INTERIA.PL (www.interia.pl)
                                                                                                                                                                                                                                                                               **/

/**
 * Created by vladyslav on 27.11.17.
 */


var _Ad = __webpack_require__(4);

var _Ad2 = _interopRequireDefault(_Ad);

var _AdsSidebar = __webpack_require__(5);

var _AdsSidebar2 = _interopRequireDefault(_AdsSidebar);

var _AdSidebarService = __webpack_require__(6);

var _AdSidebarService2 = _interopRequireDefault(_AdSidebarService);

var _helper = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (w, d) {
    console.warn('------------------ Ads_sidebar ------------------');

    var mainContentSelector = '.main-content',
        adsSidebarSelector = '#content .main-sidebar';

    // let isResized
    w.Inpl = w.Inpl || {};
    w.Inpl.adsSidebar = { services: [] };

    var isDefined = function isDefined(el) {
        return typeof el !== 'undefined';
    },
        isObject = function isObject(el) {
        return isDefined(el) && (typeof el === 'undefined' ? 'undefined' : _typeof(el)) === 'object';
    },

    /**
     * main action func
     */
    main = function main(contentSel, adsSidebarSel) {
        try {
            var content = null,
                adsSidebar = null;

            if (!isDefined(contentSel)) {
                return false;
            }

            if (!isDefined(adsSidebarSel)) {
                return false;
            }

            if (isObject(contentSel)) {
                content = contentSel;
            } else {
                content = d.querySelector(contentSel);
            }

            if (isObject(adsSidebarSel)) {
                adsSidebar = adsSidebarSel;
            } else {
                adsSidebar = d.querySelector(adsSidebarSel);
            }

            w.Inpl.testSlots = adsSidebar;

            var ads = [],
                adHeights = 0;

            if (content && adsSidebar) {

                var adsSidebarDivStyle = getComputedStyle(adsSidebar),
                    sidebarAds = adsSidebar.children;

                adsSidebar.style.height = content.clientHeight + 'px';

                if (adsSidebarDivStyle.display === 'block') {

                    Object.keys(sidebarAds).forEach(function (key) {
                        var element = sidebarAds[key];

                        if ((typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object' && element.clientHeight > 0) {

                            console.warn('element id: ', element.id);
                            console.warn('clientHeight: ', element.clientHeight);
                            console.warn('height calc: ', (0, _helper.outerHeightWithMargin)(element));

                            var height = (0, _helper.outerHeightWithMargin)(element);
                            adHeights += height;

                            ads.push(new _Ad2.default({
                                element: element,
                                place: element.id,
                                adsSidebar: adsSidebar,
                                w: w,
                                height: height
                            }));
                        }
                    });

                    var sidebar = new _AdsSidebar2.default({
                        ads: ads,
                        element: adsSidebar,
                        contentHeight: content.clientHeight,
                        adHeights: adHeights
                    });

                    sidebar.calcOffsetTop();

                    var service = new _AdSidebarService2.default(sidebar);
                    service.contentSelector = contentSel;
                    service.adsSidebarSelector = adsSidebarSel;

                    if (content.clientHeight > adHeights) {
                        service.calcVisibilityRanges();
                        service.updateAdsPositions();

                        var serviceExists = w.Inpl.adsSidebar.services.find(function (s) {
                            return s.contentSelector === contentSel;
                        });

                        if (!serviceExists) {
                            w.Inpl.adsSidebar.services.push(service);
                        }
                    }

                    // w.addEventListener('scroll', () => {
                    //     if (content.clientHeight > adHeights) {
                    //         const { services } = w.Inpl.adsSidebar;
                    //
                    //         services.forEach(s => doOnResize(s));
                    //     }
                    // });
                }
            }
        } catch (e) {
            console.error(e);
        }
    };

    /**
     * do height calculation for each slot, content and article
     */
    var doOnResize = function doOnResize(service) {
        var sidebar = service.sidebar,
            content = d.querySelector(service.contentSelector),
            adsSidebarDiv = d.querySelector(service.adsSidebarSelector),
            children = adsSidebarDiv.children,
            adsSidebarDivStyle = getComputedStyle(adsSidebarDiv);


        adsSidebarDiv.style.height = content.clientHeight + 'px';

        if (adsSidebarDivStyle.display === 'block') {

            var sidebarAds = new Map(),
                adHeights = 0;

            Object.keys(children).forEach(function (key) {
                sidebarAds.set(children[key].id, children[key]);
            });

            sidebar._ads.forEach(function (ad) {
                var slot = sidebarAds.get(ad.element.id),
                    height = (0, _helper.outerHeightWithMargin)(slot);

                ad.height = height;
                adHeights += height;

                return ad;
            });

            sidebar.calcOffsetTop();
            sidebar.adHeights = adHeights;
            sidebar.contentHeight = content.clientHeight;

            service.sidebar = sidebar;
            service.calcVisibilityRanges();
            service.updateAdsPositions();
        }
    };

    w.Inpl.adsSidebar.runSidebar = main;

    // for new ads service Inpl.uanc
    w.addEventListener('Inpl.adsLoaded', function adsLoadedHandler(e) {
        var target = e.target,
            type = e.type;


        target.removeEventListener(type, adsLoadedHandler);

        if (w.innerWidth > 999) {

            main(mainContentSelector, adsSidebarSelector);

            w.addEventListener('resize', function () {
                var services = w.Inpl.adsSidebar.services;


                setTimeout(function () {
                    services.forEach(function (service) {
                        return doOnResize(service);
                    });
                }, 100);
            });

            w.addEventListener('portalTopped', function portalToppedHandler(portalToppedEvent) {

                portalToppedEvent.target.removeEventListener(portalToppedEvent.type, portalToppedHandler);

                var services = w.Inpl.adsSidebar.services;


                setTimeout(function () {
                    services.forEach(function (service) {
                        return doOnResize(service);
                    });
                }, 100);
            });

            w.addEventListener('renderForum', function renderForumHandler(renderForumEvent) {
                renderForumEvent.target.removeEventListener(renderForumEvent.type, renderForumHandler);

                var services = w.Inpl.adsSidebar.services;


                setTimeout(function () {
                    services.forEach(function (service) {
                        return doOnResize(service);
                    });
                }, 100);
            });
        }
    });

    /**
     * main app entry
     * collect all promises
     */
    (0, _helper.windowLoaded)().then(function () {

        var self = w.Inpl.Ad;

        if (!self.hasOwnProperty('isNewService') && w.innerWidth > 999) {

            setTimeout(function () {
                return main(mainContentSelector, adsSidebarSelector);
            }, 2000);

            w.addEventListener('scroll', function () {
                var services = w.Inpl.adsSidebar.services;


                services.forEach(function (s) {
                    return doOnResize(s);
                });
            });

            w.addEventListener('resize', function () {
                var services = w.Inpl.adsSidebar.services;


                setTimeout(function () {
                    return services.forEach(function (service) {
                        return doOnResize(service);
                    });
                }, 300);
            });

            w.addEventListener('portalTopped', function portalToppedHandler(e) {
                e.target.removeEventListener(e.type, portalToppedHandler);

                var services = w.Inpl.adsSidebar.services;


                setTimeout(function () {
                    services.forEach(function (service) {
                        return doOnResize(service);
                    });
                }, 100);
            });

            w.addEventListener('renderForum', function renderForumHandler(e) {
                e.target.removeEventListener(e.type, renderForumHandler);

                var services = w.Inpl.adsSidebar.services;


                setTimeout(function () {
                    services.forEach(function (service) {
                        return doOnResize(service);
                    });
                }, 100);
            });
        }
    });
})(window, document);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2017.  INTERIA.PL (www.interia.pl)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      **/

/**
 * Created by vladyslav on 27.11.17.
 */


var _helper = __webpack_require__(0);

var _config = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Ad = function () {
    function Ad(_ref) {
        var element = _ref.element,
            adsSidebar = _ref.adsSidebar,
            place = _ref.place,
            _ref$minVisibilityRan = _ref.minVisibilityRange,
            minVisibilityRange = _ref$minVisibilityRan === undefined ? 0 : _ref$minVisibilityRan,
            _ref$maxVisibilityRan = _ref.maxVisibilityRange,
            maxVisibilityRange = _ref$maxVisibilityRan === undefined ? 0 : _ref$maxVisibilityRan,
            _ref$height = _ref.height,
            height = _ref$height === undefined ? 0 : _ref$height,
            w = _ref.w;

        _classCallCheck(this, Ad);

        this.element = element; // ad html element
        this.adsSidebar = adsSidebar; // sidebar html element
        this.place = place; // Nazwa miejsca reklamowego
        this.minVisibilityRange = minVisibilityRange;
        this.maxVisibilityRange = maxVisibilityRange;
        this.height = height; // ad height
        this.w = w;
    }

    /**
     * count ad's position
     * @param sidebar
     */


    _createClass(Ad, [{
        key: 'updatePosition',
        value: function updatePosition(sidebar) {
            var style = this.element.style;


            var positionTop = Ad.calcPositionTop(sidebar);

            if (positionTop <= this.minVisibilityRange) {
                // ad position when positionTop value is between min/max
                style.top = this.minVisibilityRange + 'px';
                style.position = 'absolute';
            } else if (this.maxVisibilityRange <= positionTop) {
                // ad position when positionTop value is greater then max
                style.top = this.maxVisibilityRange + 'px';
                style.position = 'absolute';
            } else {
                // fix ad on top
                style.top = _config.OFFSET_TOP + 'px';
                style.position = 'fixed';
            }
        }

        /**
         * calculate top position
         * @param sidebar
         * @returns {number}
         */

    }, {
        key: 'calcVisibilityRange',
        value: function calcVisibilityRange(sidebar) {
            var ads = sidebar.ads,
                adHeights = sidebar.adHeights,
                contentHeight = sidebar.contentHeight;

            var adsLength = ads.length;
            var prevAdsHeight = this.calcPrevAdsHeights(sidebar);
            var innerHeight = this.w.innerHeight;

            var index = this.index(sidebar); // ad's id
            var lastAd = this.isLast(sidebar);
            var movableAdsQuantity = Math.max(2, adsLength) - 1;

            var sidebarHeight = void 0;
            var height = void 0;

            if (innerHeight > 600) {
                sidebarHeight = innerHeight / 6 + adHeights;
            } else {
                sidebarHeight = 0;
            }
            height = sidebarHeight;

            // count min visibility value
            this.minVisibilityRange = Math.max(prevAdsHeight, height * index / movableAdsQuantity);
            // count max visibility value
            this.maxVisibilityRange = height * (index + 1) / movableAdsQuantity;

            if (adsLength > 1) {
                this.height = (0, _helper.outerHeightWithMargin)(this.element);
                this.maxVisibilityRange -= this.height; //outerHeightWithMargin(this.element);
            }

            if (this.maxVisibilityRange < 0) {
                // fix max visibility value if it has minus value
                this.maxVisibilityRange = 0;
            }

            if (lastAd) {
                // to do last ad visible at the end of page
                // do max visibility with main content
                this.maxVisibilityRange = contentHeight - this.height; // - (this.height / 10);
            }
        }

        /**
         * calculate previous ads heights
         * @param sidebar
         * @returns {*}
         */

    }, {
        key: 'calcPrevAdsHeights',
        value: function calcPrevAdsHeights(sidebar) {
            var prevAds = this.prevAds(sidebar);
            return prevAds.reduce(function (height, ad) {
                return height + (0, _helper.outerHeightWithMargin)(ad.element);
            }, 0);
        }

        /**
         * get previous ads
         * @param sidebar
         * @returns {Array.<T>}
         */

    }, {
        key: 'prevAds',
        value: function prevAds(sidebar) {
            return sidebar.ads.slice(0, this.index(sidebar));
        }

        /**
         * move to the next ad
         * @param ads
         * @returns {*}
         */

    }, {
        key: 'nextAd',
        value: function nextAd(_ref2) {
            var ads = _ref2.ads;

            var idx = ads.indexOf(this);
            if (idx + 1 < ads.length) {
                return ads[idx + 1];
            }

            return ads[idx];
        }

        /**
         * get ad's index
         * @param ads
         */

    }, {
        key: 'index',
        value: function index(_ref3) {
            var ads = _ref3.ads;

            return ads.indexOf(this);
        }

        /**
         * get last ad
         * @param sidebar
         * @returns {boolean}
         */

    }, {
        key: 'isLast',
        value: function isLast(sidebar) {
            return this === sidebar.getLastAd();
        }
    }], [{
        key: 'calcPositionTop',
        value: function calcPositionTop(sidebar) {
            return window.pageYOffset - sidebar.offsetTop;
        }
    }]);

    return Ad;
}();

exports.default = Ad;
module.exports = exports['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2017.  INTERIA.PL (www.interia.pl)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      **/

/**
 * Created by vladyslav on 27.11.17.
 */


var _config = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdsSidebar = function () {
    function AdsSidebar(_ref) {
        var element = _ref.element,
            _ref$ads = _ref.ads,
            ads = _ref$ads === undefined ? [] : _ref$ads,
            _ref$offsetTop = _ref.offsetTop,
            offsetTop = _ref$offsetTop === undefined ? 0 : _ref$offsetTop,
            contentHeight = _ref.contentHeight,
            adHeights = _ref.adHeights;

        _classCallCheck(this, AdsSidebar);

        this.element = element;
        this.ads = ads;
        this.offsetTop = offsetTop;
        this.contentHeight = contentHeight;
        this.adHeights = adHeights;
    }

    _createClass(AdsSidebar, [{
        key: 'calcOffsetTop',


        /**
         * calculate offset top
         */
        value: function calcOffsetTop() {
            this.offsetTop = this.element.offsetTop - _config.OFFSET_TOP;
        }

        /**
         * get ads elements
         * @returns {Array}
         */

    }, {
        key: 'getAdsElements',
        value: function getAdsElements() {
            return this.ads.map(function (ad) {
                return ad.element;
            });
        }

        /**
         * get last ad
         * @returns {Ad}
         */

    }, {
        key: 'getLastAd',
        value: function getLastAd() {
            return this.ads[this.ads.length - 1];
        }
    }, {
        key: 'ads',
        set: function set(ads) {
            this._ads = ads;
        },
        get: function get() {
            return this._ads;
        }
    }, {
        key: 'contentHeight',
        set: function set(contentHeight) {
            this._contentHeight = contentHeight;
        },
        get: function get() {
            return this._contentHeight;
        }
    }, {
        key: 'adHeights',
        set: function set(adHeights) {
            this._adHeights = adHeights;
        },
        get: function get() {
            return this._adHeights;
        }
    }]);

    return AdsSidebar;
}();

exports.default = AdsSidebar;
module.exports = exports['default'];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2017.  INTERIA.PL (www.interia.pl)
 **/

/**
 * Created by vladyslav on 27.11.17.
 */

var AdSidebarService = function () {
    function AdSidebarService(sidebar) {
        _classCallCheck(this, AdSidebarService);

        this.sidebar = sidebar;
        this.contentSelector = null;
        this.adsSidebarSelector = null;
    }

    _createClass(AdSidebarService, [{
        key: "updateAdsPositions",


        /**
         * update ads positions
         */
        value: function updateAdsPositions() {
            var _this = this;

            this.sidebar.ads.forEach(function (ad) {
                return ad.updatePosition(_this.sidebar);
            });
        }

        /**
         * calculate ads visibility ranges
         */

    }, {
        key: "calcVisibilityRanges",
        value: function calcVisibilityRanges() {
            var sidebar = this.sidebar;

            this.sidebar.ads.forEach(function (ad) {
                return ad.calcVisibilityRange(sidebar);
            });
        }
    }, {
        key: "contentSelector",
        set: function set(contentSelector) {
            this._contentSelector = contentSelector;
        },
        get: function get() {
            return this._contentSelector;
        }
    }, {
        key: "adsSidebarSelector",
        set: function set(adsSidebarSelector) {
            this._adsSidebarSelector = adsSidebarSelector;
        },
        get: function get() {
            return this._adsSidebarSelector;
        }
    }]);

    return AdSidebarService;
}();

exports.default = AdSidebarService;
module.exports = exports["default"];

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// inpl.ads-sidebar.js